<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList">
        <template slot="buttonSlot">
          <el-form-item class="toolbar-btn-item">
            <el-button
              type="warning"
              plain
              icon="el-icon-guide"
              class="kq-guide-btn"
              @click="guideDialogVisible = true">
              配置指南与避坑案例
            </el-button>
          </el-form-item>
        </template>
      </toolbar>

      <!-- 学校主备方案：列表始终编辑当前生效套；切换后可再改配置。创建于 2026-09-20 -->
      <div class="scheme-page-bar" v-if="DepartmentId">
        <el-tag size="small" :type="schoolSchemeSlot === 2 ? 'warning' : 'success'">
          当前生效：{{ activeSchemeName }}
        </el-tag>
        <el-tag v-if="!schemeHasBackup" size="mini" type="info">尚未创建备用</el-tag>
        <el-tag v-else size="mini" type="info">备用：{{ inactiveSchemeName }}</el-tag>
        <div class="scheme-page-actions">
          <el-button type="primary" size="mini" :loading="schemeBusy" @click="openSwitchSchemeDialog">
            切换生效方案
          </el-button>
          <el-button type="success" plain size="mini" :loading="schemeBusy" @click="createBackup">
            创建/更新备用
          </el-button>
          <el-button type="text" size="mini" icon="el-icon-edit" @click="renameSchemes">改方案名</el-button>
        </div>
      </div>

      <!-- 选择要生效的方案 -->
      <el-dialog
        title="切换生效方案"
        :visible.sync="switchSchemeDialogVisible"
        width="460px"
        append-to-body
        custom-class="scheme-switch-dialog">
        <div class="scheme-pick">
          <div
            class="scheme-pick-card"
            :class="{
              'is-active': switchTargetSlot === 1,
              'is-current': schoolSchemeSlot === 1
            }"
            @click="switchTargetSlot = 1">
            <div class="scheme-pick-card__top">
              <i class="el-icon-s-flag scheme-pick-card__icon"></i>
              <span v-if="schoolSchemeSlot === 1" class="scheme-pick-badge">当前生效</span>
            </div>
            <div class="scheme-pick-card__name">{{ schemeSlot1Name }}</div>
            <div class="scheme-pick-card__desc">方案一</div>
          </div>
          <div
            class="scheme-pick-card"
            :class="{
              'is-active': switchTargetSlot === 2,
              'is-current': schoolSchemeSlot === 2,
              'is-disabled': !schemeHasBackup
            }"
            @click="schemeHasBackup && (switchTargetSlot = 2)">
            <div class="scheme-pick-card__top">
              <i class="el-icon-s-opportunity scheme-pick-card__icon"></i>
              <span v-if="schoolSchemeSlot === 2" class="scheme-pick-badge">当前生效</span>
              <span v-else-if="!schemeHasBackup" class="scheme-pick-badge is-muted">未创建备用</span>
            </div>
            <div class="scheme-pick-card__name">{{ schemeSlot2Name }}</div>
            <div class="scheme-pick-card__desc">{{ schemeHasBackup ? '方案二 · 备用' : '请先创建备用' }}</div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="switchSchemeDialogVisible = false">取消</el-button>
          <el-button type="primary" size="small" :loading="schemeBusy" @click="confirmSwitchScheme">确定切换</el-button>
        </div>
      </el-dialog>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>

        <el-table-column prop="ScheduleName" label="规则名称" width="">
        </el-table-column>

        <el-table-column prop="UserRole" label="人员类型" width="" :formatter="formatSex">
        </el-table-column>

        <el-table-column prop="DepartmentName" label="所属机构" width="">
        </el-table-column>

        <el-table-column prop="DeptNames" label="应用部门" min-width="190">
          <template slot-scope="scope">
            <el-button
              v-if="parseDeptNames(scope.row.DeptNames).length"
              type="text"
              size="small"
              icon="el-icon-office-building"
              class="kq-dept-link-btn"
              @click.stop="openDeptViewDialog(scope.row)">
              已选 {{ parseDeptNames(scope.row.DeptNames).length }} 个部门
            </el-button>
            <el-tag
              v-else-if="scope.row.LiveTypeNames"
              size="small"
              type="success"
              effect="plain"
              class="kq-scope-tag">
              <i class="el-icon-circle-check"></i> 全校【{{ scope.row.LiveTypeNames }}】通用
            </el-tag>
            <el-tag
              v-else-if="scope.row.IsDefaultSchedule"
              size="small"
              type="primary"
              effect="plain"
              class="kq-scope-tag">
              <i class="el-icon-star-on"></i> 全校默认规则
            </el-tag>
            <el-tag
              v-else
              size="small"
              type="info"
              effect="plain"
              class="kq-scope-tag">
              全校通用（未限制部门）
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="LiveTypeNames" label="应用人员类型" min-width="120" show-overflow-tooltip>
        </el-table-column>

        <!-- <el-table-column prop="IsDefaultSchedule" label="默认" width="">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsDefaultSchedule == 1 ? 'success' : 'danger'" disable-transitions>{{
              scope.row.IsDefaultSchedule == 1
                ?
                "√" : "×" }}
            </el-tag>
          </template>

        </el-table-column> -->

        <el-table-column fixed="right" label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button @click="ShowDailyTime(scope.row)" type="text">考勤时间</el-button>
          </template>
        </el-table-column>

      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>
      <!--编辑界面-->
      <el-dialog title="编辑考勤规则" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">

          <el-form-item label="规则名称" prop="ScheduleName">
            <el-input v-model="editForm.ScheduleName" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="适用类型">
            <el-tag type="warning" size="small">学生（固定）</el-tag>
          </el-form-item>

          <!-- <el-form-item label="是否默认" prop="IsDefaultSchedule" width>
            <el-switch v-model="editForm.IsDefaultSchedule"></el-switch>
          </el-form-item> -->

          <el-form-item label="应用部门">
            <el-cascader style="width: 100%" v-model="editForm.DeptIds" :show-all-levels="false" :options="allOptions"
              :key="isResouceShow" :props="{ multiple: true }" clearable></el-cascader>
            <div class="kq-field-tip">
              <i class="el-icon-info"></i> 留空不选部门时：若指定了人员类型，将作为<strong>全校该类型通用规则</strong>生效，无需逐班选择。
            </div>
          </el-form-item>

          <el-form-item label="应用人员类型">
            <el-select v-model="editForm.LiveTypeIds" style="width: 100%" multiple placeholder="请选择人员类型">
              <el-option v-for="item in liveTypeList" :key="item.LiveTypeId" :label="item.LiveTypeName"
                :value="item.LiveTypeId"></el-option>
            </el-select>

          </el-form-item>
 
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增考勤规则" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm" class="demo-form-inline">

          <el-form-item label="规则名称" prop="ScheduleName">
            <el-input v-model="addForm.ScheduleName" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="适用类型">
            <el-tag type="warning" size="small">学生（固定）</el-tag>
          </el-form-item>

          <!-- <el-form-item label="是否默认" prop="IsDefaultSchedule" width>
            <el-switch v-model="addForm.IsDefaultSchedule"></el-switch>
          </el-form-item> -->

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--设置考勤时间-->
      <el-dialog :title="dailyTimeTitle" :visible.sync="dailyTimeDialogVisible" center width="780px">
        <el-alert
          title="配置须知：如住宿类型周日返校或周五放学时间不同，可通过【新增】配置多条不同星期的排班。打卡时间须在开始与结束时间范围内，否则判定为【无效时间】。"
          type="info"
          :closable="false"
          show-icon
          style="margin-bottom: 12px;">
          <template slot="default">
            <span style="margin-left: 8px;">
              <el-button type="text" size="mini" icon="el-icon-reading" @click="guideDialogVisible = true">查看配置指南与案例</el-button>
            </span>
          </template>
        </el-alert>

        <div style="display: flex; justify-content: flex-end; gap: 8px; margin-bottom: 10px;">
          <el-button type="primary" @click="openDailyTimedialog(1)">新增</el-button>
          <el-button type="primary" @click="openDailyTimedialog(0)">编辑</el-button>
          <el-button type="danger" @click="delDailyTime()">删除</el-button>
        </div>

        <el-table :data="dailyTimeTitleData" @select="dailyTimeTitleCheck" @row-click="dailyTimeSelectCurrentRow"
          ref="dailyTimeTitleTable" class="custom-tbl" style="width: 100%">
          <el-table-column type="selection"> </el-table-column>
          <el-table-column property="UsingWeekDayStr" label="日期"></el-table-column>
          <el-table-column property="TimeDataStr" label="时间设定"></el-table-column>

        </el-table>

        <!--工具条-->
        <div class="toolbar" style="text-align: right; padding: 10px 0;">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentDailyTimeChange"
            :page-size="10" :total="dailyTimeTotal">
          </el-pagination>
        </div>

      </el-dialog>

      <el-dialog
        width="65%"
        title="每日考勤时间设定"
        :visible.sync="dailyTimeInnerVisible"
        append-to-body
        custom-class="daily-time-setting-dialog"
      >
        <div class="daily-inner-alert-wrap">
          <el-alert
            title="避坑警示：打卡时间必须落在【开始时间 ~ 结束时间】之内，早于开始或晚于结束均提示【无效时间】！建议开始时间提前 45-60 分钟，结束时间延后 30-60 分钟。"
            type="warning"
            :closable="false"
            show-icon
            style="margin-bottom: 10px;">
            <template slot="default">
              <span style="margin-left: 8px;">
                <el-button type="text" size="mini" icon="el-icon-guide" @click="guideDialogVisible = true">查看避坑指南与案例说明</el-button>
              </span>
            </template>
          </el-alert>
        </div>

        <el-form label-width="80px">

          <div class="daily-time-table-wrap">
            <el-table border :data="tableData" class="daily-time-table" style="width: 100%">
              <el-table-column label="登记" width="100" align="center" header-align="center">
                <template slot-scope="scope">
                  <span>第{{ scope.$index + 1 }}次登记</span>
                </template>
              </el-table-column>

              <el-table-column label="考勤时间" min-width="550" align="center" header-align="center">
                <template slot-scope="scope">
                  <dailyForm :row="scope.row" @update:form="val => handleUpdateForm(val, scope.$index)" />
                </template>
              </el-table-column>

              <el-table-column label="类型" width="70" align="center" header-align="center">
                <template slot-scope="scope">
                  {{ (scope.$index + 1) % 2 == 0 ? '离开' : '进入' }}
                </template>
              </el-table-column>

              <!-- 自动考勤开关：开启后无需学生刷脸，定时任务在准点时间自动生成考勤记录 -->
              <el-table-column label="自动考勤" width="90" align="center" header-align="center">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.isAutoKaoqin"
                    active-color="#2563eb"
                    @change="val => handleAutoKaoqinChange(val, scope.$index)"
                  ></el-switch>
                </template>
              </el-table-column>

            </el-table>
          </div>

          <el-form-item label="有效星期" class="daily-time-week-item">
            <el-checkbox-group v-model="usingWeekDays">
              <el-checkbox v-for="item in usingWeekDaysOptions" :key="item.value" :label="item.value"
                :disabled="item.disabled">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dailyTimeInnerVisible = false">取 消</el-button>
          <el-button type="primary" @click.native="savaDailyTimeSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 列表应用部门查看弹窗。最后更新：2026-09-08 -->
      <el-dialog :title="viewDeptDialog.title" :visible.sync="viewDeptDialog.visible" width="640px"
        :close-on-click-modal="false" append-to-body custom-class="kq-dept-view-dialog">
        <div class="kq-view-head">
          <div class="kq-view-head-item">
            <span class="label">规则：</span>
            <span class="val">{{ viewDeptDialog.scheduleName || '-' }}</span>
          </div>
          <div class="kq-view-head-item">
            <span class="label">机构：</span>
            <span class="val">{{ viewDeptDialog.departmentName || '-' }}</span>
          </div>
          <div class="kq-view-head-item">
            <span class="label">人员类型：</span>
            <span class="val">{{ viewDeptDialog.liveTypeNames || '全部' }}</span>
          </div>
          <div class="kq-view-head-item">
            <span class="label">总数：</span>
            <span class="val count-badge">{{ viewDeptDialog.depts ? viewDeptDialog.depts.length : 0 }} 个部门</span>
          </div>
        </div>

        <div class="kq-view-toolbar">
          <el-input v-model="viewDeptDialog.filterKey" size="small" placeholder="搜索部门 / 班级名称..." prefix-icon="el-icon-search"
            clearable class="kq-view-search-input" />
          <el-button size="small" type="primary" plain icon="el-icon-document-copy" @click="copyAllDeptNames">
            复制全部部门
          </el-button>
        </div>

        <div class="kq-view-table-wrap">
          <el-table :data="filteredViewDepts" size="small" max-height="340" border stripe class="kq-view-table">
            <el-table-column type="index" label="序号" width="70" align="center" />
            <el-table-column prop="name" label="部门 / 班级名称" min-width="260">
              <template slot-scope="scope">
                <span class="dept-text">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="mini" icon="el-icon-document-copy" @click="copySingleDeptName(scope.row.name)">复制</el-button>
              </template>
            </el-table-column>
            <div slot="empty" class="kq-view-empty">暂无匹配的部门</div>
          </el-table>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="viewDeptDialog.visible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 考勤规则配置指南与经典案例弹窗。最后更新：2026-09-08 -->
      <el-dialog
        title="考勤规则配置指南"
        :visible.sync="guideDialogVisible"
        width="760px"
        append-to-body
        custom-class="kq-guide-dialog"
      >
        <div class="kq-guide-container">
          <el-tabs v-model="activeGuideTab" type="border-card" class="kq-guide-tabs">

            <!-- Tab 1: 核心要诀 -->
            <el-tab-pane label="💡 核心配置要诀（避免报错）" name="pitfalls">
              <div class="guide-cards-grid">

                <div class="mini-guide-card info">
                  <div class="card-head">
                    <i class="el-icon-school"></i>
                    <span class="card-title">规则 1：应用部门与人员类型</span>
                  </div>
                  <div class="card-body">
                    <div class="point-item">
                      <span class="tag green">类型可全校通用</span>
                      <p>应用部门<strong>留空（不选班级）</strong>，仅选某一人员类型，全校该类型自动默认继承该规则，无需逐班重复配置。</p>
                    </div>
                    <div class="point-item">
                      <span class="tag blue">按班生效</span>
                      <p>若各年级作息不同，在【应用部门】中勾选对应的具体班级即可。</p>
                    </div>
                    <div class="tip-line danger-text">
                      <i class="el-icon-warning-outline"></i> 打卡提示【未指定考勤规则】：请检查班级是否遗漏勾选，或学生档案是否维护了人员类型。
                    </div>
                  </div>
                </div>

                <div class="mini-guide-card warning">
                  <div class="card-head">
                    <i class="el-icon-time"></i>
                    <span class="card-title">规则 2：时间范围与有效星期</span>
                  </div>
                  <div class="card-body">
                    <div class="point-item">
                      <span class="tag orange">留足时间弹性</span>
                      <p>打卡必须在【开始 ~ 结束】时间内！建议<strong>开始提前 45-60 分钟</strong>，<strong>结束延后 45-60 分钟</strong>，防止学生早到或晚离被判为【无效时间】。</p>
                    </div>
                    <div class="point-item">
                      <span class="tag purple">周末星期勾选</span>
                      <p>住宿类型周日晚返校、或周末补课打卡的，【有效星期】务必勾选<strong>星期日</strong>或<strong>星期六</strong>。</p>
                    </div>
                    <div class="tip-line warning-text">
                      <i class="el-icon-info"></i> 打卡提示【无效时间】：99% 属于打卡时刻早于开始时间，或当天星期未在排班中勾选。
                    </div>
                  </div>
                </div>

              </div>
            </el-tab-pane>

            <!-- Tab 2: 常用参考 -->
            <el-tab-pane label="📋 推荐作息参考" name="cases">
              <div class="guide-case-content">
                <div class="table-group-title">日间类型推荐作息（周一至周五）</div>
                <el-table :data="caseTable1" size="mini" border stripe class="mini-case-table">
                  <el-table-column prop="seq" label="顺位" width="80" align="center" />
                  <el-table-column prop="type" label="进出方向" width="100" align="center">
                    <template slot-scope="s"><span :class="s.row.typeClass">{{ s.row.type }}</span></template>
                  </el-table-column>
                  <el-table-column prop="start" label="开始" width="80" align="center" />
                  <el-table-column prop="ontime" label="准点" width="80" align="center" />
                  <el-table-column prop="end" label="结束" width="80" align="center" />
                  <el-table-column prop="desc" label="业务规则说明" />
                </el-table>

                <div class="table-group-title" style="margin-top: 14px;">住宿类型周日返校推荐（仅星期日）</div>
                <div class="dorm-case-box">
                  <span class="badge">第 1 次登记（进入）</span>
                  <span class="time-slot">开始 <strong>16:00</strong> &nbsp;|&nbsp; 准点 <strong>18:30</strong> &nbsp;|&nbsp; 结束 <strong>21:00</strong></span>
                  <span class="desc">（16:00~18:30 正常返校，18:30~21:00 迟到，其余时间无效）</span>
                </div>

                <div class="timeline-visual">
                  <div class="vis-title">⏱️ 打卡进出判定示意：</div>
                  <div class="vis-row">
                    <span class="vis-label">进入（上学/返校）：</span>
                    <span class="vis-bar normal">开始 ~ 准点（正常到校）</span>
                    <span class="vis-bar late">准点 ~ 结束（迟到）</span>
                  </div>
                  <div class="vis-row">
                    <span class="vis-label">离开（放学/离校）：</span>
                    <span class="vis-bar early">开始 ~ 准点（早退）</span>
                    <span class="vis-bar normal">准点 ~ 结束（正常离校）</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>

          </el-tabs>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="guideDialogVisible = false">我已了解</el-button>
        </div>
      </el-dialog>

    </section>
  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getKqtScheduleTypeListPage, removeKqtScheduleType, editKqtScheduleType, addKqtScheduleType, getKqtScheduleDailySettingListPage, getDailyTime, removeKqtScheduleDailySetting, addKqtScheduleDailySetting } from '../../api/modules/attendance';
import { getSchoolSchemeProfile, saveSchoolSchemeProfile, createOrUpdateBackup, batchSwitch } from '../../api/modules/scheme-switch';
import { getTeachingDepartmentTree, getSubDepartmentTree, getStudentLiveTypeList } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import dailyForm from "../../components/dailyForm.vue";

export default {
  components: { Toolbar, DepartmentPane, dailyForm },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      options: [],
      allOptions: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        ScheduleName: [
          { required: true, message: "请输入规则名称", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        ScheduleName: "",
        DepartmentId: 0,
        UserRole: "",
        IsDefaultSchedule: true,
        DeptIds: [],
        DeptIdStr: "",
        LiveTypeIds: [],
        LiveTypeId: ''
      },
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        ScheduleName: [
          { required: true, message: "请输入规则名称", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        ScheduleName: "",
        DepartmentId: 0,
        UserRole: "",
        IsDefaultSchedule: false
      },
      DepartmentId: 0,
      imageUrl: '',
      imageLoadding: false,
      //考勤时间
      dailyTimeDialogVisible: false,
      dailyTimeTitle: "",
      currentDailyTimeRow: null,
      dailyTimeInnerVisible: false,
      dailyTimeForm: {},
      dailyTimeTitleData: [],
      dailyTimePage: 0,
      dailyTimeTotal: 1,
      // 学校主备方案。创建于 2026-09-20
      schemeSlot1Name: '方案一',
      schemeSlot2Name: '方案二',
      schoolSchemeSlot: 1,
      schemeHasBackup: false,
      schemeBusy: false,
      switchSchemeDialogVisible: false,
      switchTargetSlot: 1,
      //考勤的时间
      tableData: [],
      dailyTimeRowCount: 6,
      //有效星期
      usingWeekDays: [],
      usingWeekDaysOptions: [
        { label: '星期一', value: '1', disabled: false },
        { label: '星期二', value: '2', disabled: false },
        { label: '星期三', value: '3', disabled: false },
        { label: '星期四', value: '4', disabled: false },
        { label: '星期五', value: '5', disabled: false },
        { label: '星期六', value: '6', disabled: false },
        { label: '星期日', value: '7', disabled: false }
      ],
      // 应用部门查看弹窗状态。最后更新：2026-09-08
      viewDeptDialog: {
        visible: false,
        title: '查看应用部门',
        scheduleName: '',
        departmentName: '',
        liveTypeNames: '',
        depts: [],
        filterKey: '',
      },
      // 考勤规则配置指南状态。最后更新：2026-09-08
      guideDialogVisible: false,
      activeGuideTab: 'pitfalls',
      caseTable1: [
        { seq: '第 1 次', type: '进入 (到校)', typeClass: 'type-in', start: '06:30', ontime: '07:50', end: '08:30', desc: '≤07:50 正常到校，07:50~08:30 迟到，早于06:30或晚于08:30无效' },
        { seq: '第 2 次', type: '离开 (放学)', typeClass: 'type-out', start: '16:30', ontime: '17:30', end: '19:00', desc: '<17:30 早退，17:30~19:00 正常离校，早于16:30或晚于19:00无效' }
      ],
    };
  },
  computed: {
    activeSchemeName() {
      return this.schoolSchemeSlot === 2 ? this.schemeSlot2Name : this.schemeSlot1Name;
    },
    inactiveSchemeName() {
      return this.schoolSchemeSlot === 2 ? this.schemeSlot1Name : this.schemeSlot2Name;
    },
    // 弹窗中过滤后的部门列表。最后更新：2026-09-08
    filteredViewDepts() {
      const list = this.viewDeptDialog.depts || [];
      const key = (this.viewDeptDialog.filterKey || '').trim().toLowerCase();
      if (!key) {
        return list.map((name) => ({ name }));
      }
      return list
        .filter((name) => String(name).toLowerCase().includes(key))
        .map((name) => ({ name }));
    },
  },
  methods: {
    // 解析部门名为数组
    parseDeptNames(val) {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      return String(val).split("、").map(s => s.trim()).filter(s => s.length > 0);
    },
    // 打开应用部门查看弹窗。最后更新：2026-09-08
    openDeptViewDialog(row) {
      if (!row) return;
      const deptList = this.parseDeptNames(row.DeptNames);
      this.viewDeptDialog = {
        visible: true,
        title: `查看应用部门 - ${row.ScheduleName || '考勤规则'}`,
        scheduleName: row.ScheduleName || '',
        departmentName: row.DepartmentName || '',
        liveTypeNames: row.LiveTypeNames || '',
        depts: deptList,
        filterKey: '',
      };
    },
    // 复制所有筛选出的部门
    copyAllDeptNames() {
      const depts = (this.filteredViewDepts || []).map((item) => item.name).filter(Boolean);
      if (!depts.length) {
        this.$message.warning('暂无可复制的部门');
        return;
      }
      this.copyTextToClipboard(depts.join('、'));
      this.$message.success(`已复制 ${depts.length} 个部门名称`);
    },
    // 复制单个部门
    copySingleDeptName(text) {
      if (!text) return;
      this.copyTextToClipboard(text);
      this.$message.success(`已复制: ${text}`);
    },
    // 通用剪贴板复制工具
    copyTextToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).catch(() => {
          this.fallbackCopyText(text);
        });
      } else {
        this.fallbackCopyText(text);
      }
    },
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('复制失败', err);
      }
      document.body.removeChild(textArea);
    },
    // 只显示前 20 个（5行*4个）
    getLimitedDeptNames(val) {
      return this.parseDeptNames(val).slice(0, 20);
    },
    // 是否超出
    isDeptNamesOverflow(val) {
      return this.parseDeptNames(val).length > 20;
    },
    // tooltip内容，逗号分隔，自动换行
    formatDeptNamesTooltip(val) {
      return this.parseDeptNames(val).join(', ');
    },
    handleChange(value) {
      var id = "";
      if (value.length > 1) {
        id = value[value.length - 1];
      } else {
        id = value[0];
      }

      let allpara = { pid: id, type: 1 };
      getTeachingDepartmentTree(allpara).then((res) => {
        ++this.isResouceShow;
        this.allOptions.push(res.data.response);
      });

    },
    beforeAvatarUpload(file) {
      // 这里可以过滤不要的文件
      this.imageLoadding = true
      return true
    },

    //头像上传成功
    handleAvatarSuccess(res, file) {
      this.imageLoadding = false
      console.log(res)
      this.imageUrl = res.response
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.loadSchoolSchemeProfile();
      this.handleQuery();
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    //人员类型
    formatSex: function (row, column) {
      return row.UserRole == 'student' ? "学生" : row.UserRole == 'teacher' ? "教师" : "";
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        userRole: "student",
        ...this.filters,
      }
      this.listLoading = true;

      testapi();
      //NProgress.start();
      getKqtScheduleTypeListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeKqtScheduleType(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    // 显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      console.log(row);
      this.options = [];
      this.allOptions = [];
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }

      let allpara = { pid: row.DepartmentId };
      getSubDepartmentTree(allpara).then((res) => {
        ++this.isResouceShow;
        this.allOptions.push(res.data.response);
      });

      let liveTypePara = {
        id: row.DepartmentId,
      };
      getStudentLiveTypeList(liveTypePara).then((res) => {
        this.liveTypeList = res.data.response;
      });

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    // 显示新增界面
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0) {
        this.$message({
          message: "请先选择左侧所属机构！",
          type: "warning",
        });
        return;
      }
      this.addFormVisible = true;
      this.options = [];
      this.allOptions = [];
      this.addForm = {
        ScheduleName: "",
        DepartmentId: this.DepartmentId,
        UserRole: "student",
        IsDefaultSchedule: false
      };
    },
    // 编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            para.UserRole = "student";

            let deptIdStr = "";

            para.DeptIds.forEach(element => {
              deptIdStr += element.pop() + ",";
            });

            para.DeptIdStr = deptIdStr;

            let liveTypeId = '';

            para.LiveTypeIds.forEach(element => {
              liveTypeId += element + ",";
            });

            para.LiveTypeId = liveTypeId;

            editKqtScheduleType(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    // 新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.UserRole = "student";

            addKqtScheduleType(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },

    //显示考勤时间列表
    /**
     * 加载学校方案档案。创建于 2026-09-20
     */
    loadSchoolSchemeProfile() {
      if (!this.DepartmentId) return;
      getSchoolSchemeProfile({ schoolId: this.DepartmentId, bizType: 'Attendance' }).then((res) => {
        if (!res.data.success) return;
        const p = res.data.response || {};
        this.schemeSlot1Name = p.Slot1Name || '方案一';
        this.schemeSlot2Name = p.Slot2Name || '方案二';
        this.schoolSchemeSlot = p.ActiveSlot === 2 ? 2 : 1;
        this.schemeHasBackup = !!p.HasBackup;
      });
    },
    /**
     * 修改两套方案显示名。创建于 2026-09-20
     */
    renameSchemes() {
      if (!this.DepartmentId) {
        this.$message.warning('请先选择学校');
        return;
      }
      this.$prompt('请输入方案一名称（如：冬季）', '改方案名', {
        inputValue: this.schemeSlot1Name,
        confirmButtonText: '下一步',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        const name1 = (value || '').trim();
        if (!name1) return this.$message.warning('名称不能为空');
        this.$prompt('请输入方案二名称（如：夏季）', '改方案名', {
          inputValue: this.schemeSlot2Name,
          confirmButtonText: '保存',
          cancelButtonText: '取消'
        }).then(({ value: value2 }) => {
          const name2 = (value2 || '').trim();
          if (!name2) return this.$message.warning('名称不能为空');
          saveSchoolSchemeProfile({
            schoolId: this.DepartmentId,
            bizType: 'Attendance',
            slot1Name: name1,
            slot2Name: name2
          }).then((res) => {
            if (res.data.success) {
              this.schemeSlot1Name = name1;
              this.schemeSlot2Name = name2;
              this.$message.success('方案名称已更新');
            } else {
              this.$message.error(res.data.msg || '保存失败');
            }
          });
        }).catch(() => {});
      }).catch(() => {});
    },
    /**
     * 将当前业务表写入备用（覆盖）。创建于 2026-09-20
     */
    createBackup() {
      if (!this.DepartmentId) {
        this.$message.warning('请先选择学校');
        return;
      }
      this.$confirm('将把当前生效的全部考勤规则覆盖写入备用方案，是否继续？', '创建/更新备用', {
        type: 'warning'
      }).then(() => {
        this.schemeBusy = true;
        createOrUpdateBackup({
          schoolId: this.DepartmentId,
          scope: 'Attendance'
        }).then((res) => {
          this.schemeBusy = false;
          if (res.data.success) {
            const batch = res.data.response || {};
            const fail = batch.FailCount || 0;
            if (fail > 0) {
              this.$message.error(res.data.msg || `创建备用失败：${fail} 项未成功`);
            } else {
              this.$message.success(res.data.msg || '备用已更新');
            }
            this.loadSchoolSchemeProfile();
          } else {
            this.$message.error(res.data.msg || '操作失败');
          }
        }).catch(() => { this.schemeBusy = false; });
      }).catch(() => {});
    },
    /**
     * 打开「切换生效方案」对话框（单独选择按哪套生效）。创建于 2026-09-20
     */
    openSwitchSchemeDialog() {
      if (!this.DepartmentId) {
        this.$message.warning('请先选择学校');
        return;
      }
      this.switchTargetSlot = this.schoolSchemeSlot === 2 ? 2 : 1;
      this.switchSchemeDialogVisible = true;
    },
    /**
     * 确认切换到所选方案。创建于 2026-09-20
     */
    confirmSwitchScheme() {
      const targetSlot = this.switchTargetSlot === 2 ? 2 : 1;
      if (targetSlot === this.schoolSchemeSlot) {
        this.$message.info('已是当前生效方案');
        this.switchSchemeDialogVisible = false;
        return;
      }
      if (targetSlot === 2 && !this.schemeHasBackup) {
        this.$message.warning('请先「创建/更新备用」');
        return;
      }
      const label = targetSlot === 2 ? this.schemeSlot2Name : this.schemeSlot1Name;
      this.$confirm(`确定将本校全部考勤规则切换为「${label}」生效？切换后可再重新配置；自动考勤任务需重新保存时段。`, '确认切换', {
        type: 'warning'
      }).then(() => {
        this.schemeBusy = true;
        batchSwitch({
          schoolId: this.DepartmentId,
          targetSlot: targetSlot,
          scope: 'Attendance'
        }).then((res) => {
          this.schemeBusy = false;
          if (res.data.success) {
            const batch = res.data.response || {};
            const fail = batch.FailCount || 0;
            if (fail > 0) {
              this.$message.warning(res.data.msg || `部分失败：成功${batch.SuccessCount}，失败${fail}`);
            } else {
              this.$message.success(res.data.msg || '切换成功');
            }
            this.switchSchemeDialogVisible = false;
            this.handleQuery();
            this.loadSchoolSchemeProfile();
          } else {
            this.$message.error(res.data.msg || '切换失败');
          }
        }).catch(() => { this.schemeBusy = false; });
      }).catch(() => {});
    },

    ShowDailyTime(row) {
      this.currentRow = row;
      this.dailyTimeDialogVisible = true;
      this.dailyTimeTitle = row.ScheduleName + " - 考勤时间列表";
      this.dailyTimeHandleQuery()
    },

    //考勤时间table选中
    dailyTimeTitleCheck(selection, row) {
      this.currentDailyTimeRow = null;
      this.$refs.dailyTimeTitleTable.clearSelection()
      if (selection.length === 0) {
        return
      }
      if (row) {
        this.dailyTimeSelectCurrentRow(row)
      }
    },

    //考勤时间table选中
    dailyTimeSelectCurrentRow(val) {
      if (val) {
        this.currentDailyTimeRow = val,
          this.$refs.dailyTimeTitleTable.clearSelection()
        this.$refs.dailyTimeTitleTable.toggleRowSelection(val, true)
      }
    },

    //考勤时间信息 新增：1、编辑：0
    openDailyTimedialog(type) {

      if (type == 1) {
        this.currentDailyTimeRow = null;
        if (this.$refs.dailyTimeTitleTable) {
          this.$refs.dailyTimeTitleTable.clearSelection();
        }
      }

      let row = this.currentDailyTimeRow;

      let dailySettingId = "";
      if (type == 0)
        dailySettingId = row == null ? "" : row.Id;

      let para = {
        scheduleTypeId: this.currentRow.Id,
        dailySettingId: dailySettingId
      }
      this.tableData = [];

      getDailyTime(para).then((res) => {
        if (res.data.success) {

          if (type == 0) {
            if (!row) {
              this.$message({
                message: "请选择要编辑的一行数据！",
                type: "error",
              });

              return;
            }
          }

          this.usingWeekDays = res.data.response.UsingWeekDays;
          this.usingWeekDaysOptions = res.data.response.UsingWeekDaysOptions;
          this.tableData = this.normalizeDailyTimeData(res.data.response.TimeData);

          this.dailyTimeInnerVisible = true;
          if (type == 1) {
            this.$nextTick(() => {
              if (this.$refs.dailyTimeTitleTable) {
                this.$refs.dailyTimeTitleTable.clearSelection();
              }
            });
          }

        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },

    // 新增和编辑统一展示固定 6 条登记记录
    normalizeDailyTimeData(timeData) {
      var normalizedData = (timeData || []).map(item => ({
        ...item,
        start: item && item.start ? item.start : "",
        ontime: item && item.ontime ? item.ontime : "",
        end: item && item.end ? item.end : "",
        isAutoKaoqin: item && item.isAutoKaoqin === true
      }));

      var emptyRows = Array.from({ length: this.dailyTimeRowCount }, () => ({
        start: "",
        ontime: "",
        end: "",
        isAutoKaoqin: false
      }));

      return [...normalizedData, ...emptyRows].slice(0, this.dailyTimeRowCount);
    },

    dailyTimeHandleQuery() {
      let para = {
        page: this.dailyTimePage,
        scheduleTypeId: this.currentRow.Id,
      }
      getKqtScheduleDailySettingListPage(para).then((res) => {
        this.dailyTimeTotal = res.data.response.dataCount;
        this.dailyTimeTitleData = res.data.response.data
      });
    },

    //删除
    delDailyTime() {
      let row = this.currentDailyTimeRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          let para = { id: row.Id };
          removeKqtScheduleDailySetting(para).then((res) => {
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.dailyTimeHandleQuery();
          });
        })
        .catch(() => { });
    },

    savaDailyTimeSubmit() {

      if (this.usingWeekDays.length == 0) {
        this.$message({
          message: "请选择有效星期",
          type: "error",
        });
        this.addLoading = false;
        return;
      }
      this.$confirm("确认提交吗？", "提示", {}).then(() => {
        this.addLoading = true;

        var savaData = {
          "scheduleTypeId": this.currentRow.Id,
          "timeData": this.tableData,
          "usingWeekDays": this.usingWeekDays,
          "dailySettingId": this.currentDailyTimeRow == null ? "" : this.currentDailyTimeRow.Id
        };

        addKqtScheduleDailySetting(savaData).then((res) => {
          if (util.isEmt.format(res)) {
            this.addLoading = false;
            return;
          }
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.dailyTimeInnerVisible = false;
            this.addLoading = false;
            this.dailyTimeHandleQuery();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },

    handleUpdateForm(val, index) {
      console.log(val, index)
      // 保留 isAutoKaoqin 状态，防止子组件更新时覆盖
      var currentAutoKaoqin = (this.tableData[index] && this.tableData[index].isAutoKaoqin) || false;
      this.$set(this.tableData, index, Object.assign({}, val, { isAutoKaoqin: currentAutoKaoqin }))
      console.log(this.tableData)
    },

    // 自动考勤开关变更时同步到 tableData
    handleAutoKaoqinChange(val, index) {
      var row = Object.assign({}, this.tableData[index], { isAutoKaoqin: val });
      this.$set(this.tableData, index, row);
    },

    handleCurrentDailyTimeChange(val) {
      this.dailyTimePage = val;
    },

  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>

.scheme-page-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin: 0 0 10px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 4px;
}
.scheme-page-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-left: auto;
}
.scheme-pick {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.scheme-pick-card {
  position: relative;
  padding: 16px 14px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #fafbfc;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
  user-select: none;
}
.scheme-pick-card:hover:not(.is-disabled) {
  border-color: #c0c4cc;
  background: #fff;
}
.scheme-pick-card.is-active {
  border-color: #409eff;
  background: #ecf5ff;
  box-shadow: 0 0 0 1px #409eff inset;
}
.scheme-pick-card.is-disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.scheme-pick-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  min-height: 22px;
}
.scheme-pick-card__icon {
  font-size: 18px;
  color: #909399;
}
.scheme-pick-card.is-active .scheme-pick-card__icon {
  color: #409eff;
}
.scheme-pick-badge {
  font-size: 12px;
  line-height: 18px;
  padding: 0 6px;
  border-radius: 3px;
  color: #67c23a;
  background: #f0f9eb;
}
.scheme-pick-badge.is-muted {
  color: #909399;
  background: #f4f4f5;
}
.scheme-pick-card__name {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  line-height: 1.3;
  word-break: break-all;
}
.scheme-pick-card__desc {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}

.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
</style>

<style>
/* 列表应用部门快速查看链接按钮。最后修改：2026-09-08 */
.kq-dept-link-btn {
  padding: 4px 10px;
  font-size: 13px;
  color: #2563eb;
  background-color: #eff6ff;
  border-radius: 4px;
  line-height: 18px;
  border: 1px solid #bfdbfe;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.kq-dept-link-btn:hover,
.kq-dept-link-btn:focus {
  color: #1d4ed8;
  background-color: #dbeafe;
  border-color: #93c5fd;
}

.ac-empty-dash {
  color: #9ca3af;
  font-size: 14px;
}

/* 全校通用范围徽章标签。最后更新：2026-09-08 */
.kq-scope-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  padding: 2px 8px;
}

.kq-field-tip {
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
  margin-top: 4px;
}

.kq-field-tip strong {
  color: #059669;
}

/* 应用部门查看弹窗样式。最后修改：2026-09-08 */
.kq-dept-view-dialog .el-dialog__body {
  padding: 16px 20px 10px;
}

.kq-view-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 16px;
  margin-bottom: 14px;
}

.kq-view-head-item {
  font-size: 13px;
  color: #334155;
}

.kq-view-head-item .label {
  color: #64748b;
}

.kq-view-head-item .val {
  font-weight: 500;
  color: #0f172a;
}

.kq-view-head-item .count-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 12px;
  font-size: 12px;
  background-color: #eff6ff;
  color: #2563eb;
  font-weight: 600;
}

.kq-view-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.kq-view-search-input {
  max-width: 280px;
}

.kq-view-table-wrap {
  border-radius: 4px;
  overflow: hidden;
}

.kq-view-table .dept-text {
  font-size: 13px;
  color: #1e293b;
  font-weight: 500;
}

.kq-view-empty {
  padding: 30px 0;
  color: #94a3b8;
  font-size: 13px;
}

/* 每日考勤时间设定弹窗：窄屏时横向滚动，避免时间选择器被裁切 */
.daily-time-setting-dialog {
  min-width: 640px;
  max-width: 960px;
}

.daily-time-setting-dialog .el-dialog__body {
  overflow-x: auto;
}

.daily-time-table-wrap {
  width: 100%;
  overflow-x: auto;
  margin-bottom: 16px;
}

.daily-time-table {
  min-width: 640px;
}

.daily-time-table .el-table__body .cell {
  overflow: visible;
  white-space: normal;
  line-height: normal;
  padding: 8px 6px;
}

.daily-time-week-item {
  margin-bottom: 0;
}

.daily-time-week-item .el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 0;
}

/* 考勤规则配置指南与案例样式。最后修改：2026-09-08 */
.kq-guide-btn {
  font-weight: 500;
  border-radius: 4px;
}

.daily-inner-alert-wrap {
  margin-bottom: 14px;
}

</style>

<style>
/* 考勤规则配置指南弹窗样式（全局穿透，支持 append-to-body）最后更新：2026-09-08 */
.kq-guide-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.kq-guide-dialog .el-dialog__header {
  padding: 14px 20px 12px;
  border-bottom: 1px solid #f1f5f9;
}

.kq-guide-dialog .el-dialog__title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.kq-guide-dialog .el-dialog__body {
  padding: 12px 18px 14px;
  background-color: #f8fafc;
}

.kq-guide-tabs {
  background: #fff;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.guide-cards-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 2px 0;
}

.mini-guide-card {
  background: #ffffff;
  border-radius: 6px;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
}

.mini-guide-card.info {
  border-left: 4px solid #2563eb;
}

.mini-guide-card.warning {
  border-left: 4px solid #f59e0b;
}

.mini-guide-card .card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}

.mini-guide-card .card-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mini-guide-card .point-item {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 13px;
  line-height: 1.5;
  color: #334155;
}

.mini-guide-card .point-item p {
  margin: 0;
  flex: 1;
}

.mini-guide-card .tag {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 4px;
}

.mini-guide-card .tag.green {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.mini-guide-card .tag.blue {
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #bfdbfe;
}

.mini-guide-card .tag.orange {
  background: #fffbeb;
  color: #d97706;
  border: 1px solid #fde68a;
}

.mini-guide-card .tag.purple {
  background: #f5f3ff;
  color: #7c3aed;
  border: 1px solid #ddd6fe;
}

.mini-guide-card .tip-line {
  margin-top: 2px;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.4;
}

.tip-line.danger-text {
  background: #fef2f2;
  color: #b91c1c;
}

.tip-line.warning-text {
  background: #fffbeb;
  color: #b45309;
}

/* 推荐参考 Tab */
.guide-case-content {
  padding: 2px 0;
}

.table-group-title {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 6px;
}

.mini-case-table {
  border-radius: 4px;
  overflow: hidden;
}

.dorm-case-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
}

.dorm-case-box .badge {
  background: #eff6ff;
  color: #2563eb;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
}

.dorm-case-box .time-slot strong {
  color: #0f172a;
}

.dorm-case-box .desc {
  color: #64748b;
}

.timeline-visual {
  margin-top: 12px;
  background: #f1f5f9;
  border-radius: 6px;
  padding: 10px 14px;
}

.vis-title {
  font-size: 12px;
  font-weight: 700;
  color: #334155;
  margin-bottom: 6px;
}

.vis-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  margin-top: 4px;
}

.vis-label {
  width: 120px;
  color: #475569;
}

.vis-bar {
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 11px;
}

.vis-bar.normal {
  background: #dcfce7;
  color: #15803d;
}

.vis-bar.late {
  background: #fee2e2;
  color: #b91c1c;
}

.vis-bar.early {
  background: #fef3c7;
  color: #b45309;
}
</style>